import React, { useState } from 'react';
import './FormModal.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const FormModal = ({ formType, onClose }) => {
  const [formData, setFormData] = useState({
    name: '',
    text: '',
    a: '',
    b: '',
    c: '',
    d: '',
    correct: '',
    questionImage: null,
    previewImage: null,
    aImage: null,
    bImage: null,
    cImage: null,
    dImage: null,
    aImagePreview: null,
    bImagePreview: null,
    cImagePreview: null,
    dImagePreview: null,
    questionId: '',
    answer: '',
    explanation: '',
    title: '',
    subject: '',
    topic: '',
    date: '',
    questionType: 'MCQ', // default
    correct: '',          // for radio
    correctAnswers: [],   // for checkbox multiple
  });

  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;

      //  Special handling when questionType is set to TrueFalse
    if (name === 'questionType' && value === 'TrueFalse') {
        setFormData((prev) => ({
            ...prev,
            questionType: value,
            a: 'True',
            b: 'False',
            c: '',
            d: '',
            correct: '',
            correctAnswers: []
        }));
        return;
    }
    //for all other fields
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
    setError('');
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const preview = URL.createObjectURL(file);
      setFormData((prev) => ({
        ...prev,
        questionImage: file,
        previewImage: preview
      }));
    }
  };

  const handleOptionImageChange = (e, option) => {
    const file = e.target.files[0];
    if (file) {
      const preview = URL.createObjectURL(file);
      setFormData((prev) => ({
        ...prev,
        [`${option}Image`]: file,
        [`${option}ImagePreview`]: preview,
      }));
    }
  };

  const handleCheckboxChange = (e) => {
    const value = e.target.value;
    setFormData((prev) => {
      const newAnswers = prev.correctAnswers.includes(value)
        ? prev.correctAnswers.filter((v) => v !== value)
        : [...prev.correctAnswers, value];
      return { ...prev, correctAnswers: newAnswers };
    });
  };


  const handleSubmit = (e) => {
    e.preventDefault();

    // Simple validation: check for empty fields
    const requiredFields = {
      exam: ['title', 'subject', 'topic', 'date'],
      question: ['text', 'a', 'b'],
      answer: ['questionId', 'answer', 'explanation']
    }[formType];

    // Validate correct answers
    if (formType === 'question') {
      if (formData.questionType === 'MCQ' && !formData.correct) {
        setError('Select the correct option.');
        return;
      }
      if (formData.questionType === 'Checkbox' && formData.correctAnswers.length === 0) {
        setError('Select at least one correct option.');
        return;
      }
    }
    console.log(`${formType.toUpperCase()} Submitted:`, formData);
    alert(`${formType.toUpperCase()} submitted!`);

    // reset form on close
    setFormData({
      name: '',
      text: '',
      a: '',
      b: '',
      c: '',
      d: '',
      correct: '',
      questionImage: null,
      previewImage: null,
      aImage: null,
      bImage: null,
      cImage: null,
      dImage: null,
      aImagePreview: null,
      bImagePreview: null,
      cImagePreview: null,
      dImagePreview: null,
      questionId: '',
      answer: '',
      explanation: '',
      title: '',
      subject: '',
      topic: '',
      date: '',
      questionType: 'MCQ', // default
      correct: '',          // for radio
      correctAnswers: [],   // for checkbox multiple
    });

    onClose();
  };

  const renderFields = () => {
    switch (formType) {
      case 'exam':
        return (
          <>
            <input name="title" placeholder="Exam Title" onChange={handleChange} />
            <input name="subject" placeholder="Subject" onChange={handleChange} />
            <input name='topic' placeholder='Topic' onChange={handleChange} />
            <input name="date" type="date" onChange={handleChange} />
          </>
        );
      case 'question':
        return (
          <>
            {/* Question Text */}
            <textarea name="text" placeholder="Enter Question" onChange={handleChange} rows={4} />

            {/* Question Image */}
            <label className='image-upload-label'>Upload Question Image (optional)</label>
            <input
              type="file"
              name='image'
              accept="image/*"
              onChange={handleImageChange}
              className="image-upload-input"
            />
            {formData.previewImage && (
              <img src={formData.previewImage} alt="Question Preview" className="image-preview" />
            )}

            {/* Question Type Dropdown */}
            <select name="questionType" value={formData.questionType} onChange={handleChange}>
              <option value="MCQ">Multiple Choice (Radio)</option>
              <option value="Checkbox">Multiple Answers (Checkbox)</option>
              <option value="TrueFalse">True / False</option>
            </select>

            {/* Option A */}
            <input name="a" placeholder="Option A" onChange={handleChange} />
            {formData.questionType === 'Checkbox' ? (
              <label><input type="checkbox" value="a" onChange={handleCheckboxChange} /> Correct</label>
            ) : formData.questionType === 'MCQ' ? (
              <label><input type="radio" name="correct" value="a" onChange={handleChange} /> Correct</label>
            ) : null}

            {/* Option B */}
            <input name="b" placeholder="Option B" onChange={handleChange} />
            {formData.questionType === 'Checkbox' ? (
              <label><input type="checkbox" value="b" onChange={handleCheckboxChange} /> Correct</label>
            ) : formData.questionType === 'MCQ' ? (
              <label><input type="radio" name="correct" value="b" onChange={handleChange} /> Correct</label>
            ) : null}

            {/* Option C & D only for MCQ or Checkbox */}
            {formData.questionType !== 'TrueFalse' && (
              <>
                <input name="c" placeholder="Option C" onChange={handleChange} />
                {formData.questionType === 'Checkbox' ? (
                  <label><input type="checkbox" value="c" onChange={handleCheckboxChange} /> Correct</label>
                ) : formData.questionType === 'MCQ' ? (
                  <label><input type="radio" name="correct" value="c" onChange={handleChange} /> Correct</label>
                ) : null}

                <input name="d" placeholder="Option D" onChange={handleChange} />
                {formData.questionType === 'Checkbox' ? (
                  <label><input type="checkbox" value="d" onChange={handleCheckboxChange} /> Correct</label>
                ) : formData.questionType === 'MCQ' ? (
                  <label><input type="radio" name="correct" value="d" onChange={handleChange} /> Correct</label>
                ) : null}
              </>
            )}
          </>
        );

      case 'answer':
        return (
          <>
            <input name="questionId" type="number" placeholder="Question ID" onChange={handleChange} />
            <input name="answer" placeholder="Answer Text" onChange={handleChange} />
            <textarea name="explanation" placeholder="Explanation" onChange={handleChange} />
          </>
        );
      default:
        return null;
    }
  };

  const formTitle = {
    exam: "Add Exam",
    question: "Add Question",
    answer: "Add Answers"
  }[formType];

  const handleBulkUploadClick = () => {
    toast.info("Bulk upload triggered!");
    // Add your upload logic here
  };

  const handleExportCsvClick = () => {
    toast.success("Exporting questions as CSV...");
    // Add your export logic here
  };


  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>{formTitle}</h2>
        <form onSubmit={handleSubmit}>
          {/* {renderFields()} */}

          {renderFields()}

          {error && <p className="error">{error}</p>}
          <div className="modal-buttons">
            <button type="submit">Submit</button>
            <button type="button" onClick={onClose} className='cancel-btn'>Cancel</button>
          </div>
        </form>
      </div>


    </div>
  );
};

export default FormModal;
